module.exports = __webpack_public_path__ + "media/application/images/icons/pdf-white-99a3ff95a9717fd7cff76c3adda329ec.svg";